<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="432px"
    :mask-closable="false"
    :footer="null"
    class="qwdd-close-dialog"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <template>
        <template v-if="type==='add'">
          <h2>
            {{ $t('message["853"]') }}
          </h2>
          <div class="d-tip-con">
            {{ $t('message["1194"]') }}。
          </div>
          <div class="tip-btn-box">
            <a-button
              type="primary"
              @click="addHanler"
            >
              {{ $t('message["1312"]') }}
            </a-button>
            <a-button @click="cancelHanler">
              {{ $t('message["1006"]') }}
            </a-button>
          </div>
        </template>
        <template v-else-if="type==='del'">
          <h2>
            {{ $t('message["966"]') }}
          </h2>
          <div class="d-tip-con">
            {{ $t('message["968"]') }}？
          </div>
          <div class="tip-btn-box">
            <a-button
              type="primary"
              @click="delHandler"
            >
              {{ $t('message["466"]') }}
            </a-button>
            <a-button @click="cancelHanler">
              {{ $t('message["896"]') }}
            </a-button>
          </div>
        </template>
        <template v-else>
          <h2>
            {{ editTip[0] }}<span style="color:#f57676; margin-left: -6px;">{{ editTip[1] }}</span>，<br>
            {{ $t('message["1067"]') }}？
          </h2>
          <div class="tip-btn-box">
            <a-button
              type="primary"
              @click="setHandler"
            >
              {{ $t('message["466"]') }}
            </a-button>
            <a-button @click="cancelHanler">
              {{ $t('message["896"]') }}
            </a-button>
          </div>
        </template>
      </template>
    </div>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    editTip () {
      return this.$t('message["1392"]').split('|')
    }
  },
  methods: {
    ...mapActions('config/allocationrule', ['delAllocation']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    addHanler () {
      this.$emit('addHanler')
      this.TipDialogVisible = false
    },
    setHandler () {
      this.$emit('setHanler')
      this.TipDialogVisible = false
    },
    cancelHanler () {
      this.TipDialogVisible = false
    },
    async delHandler () {
      const chain = await this.delAllocation()
      chain.params({ id: this.itemData.id })
        .onSuccess(raw => {
          this.$message.success(this.$t('message["965"]') + '！')
          this.TipDialogVisible = false
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.tip-btn-box {
  margin-top: 40px;
}
</style>
